<template>
    <v-container>
        <v-card color="white">
            <v-card-text>名前 ： {{ userName }}</v-card-text>
            <v-card-text>チャットワークID ： {{ chatwork_id }}</v-card-text>
            <v-card-text>管理ID ： {{ uid }}</v-card-text>
            <v-card-text>
                権限 ： 
                <v-chip
                    class="ml-2"
                    color="primary"
                    text-color="white"
                    v-show="role && role.attend_s"
                    >
                    セミナー参加
                </v-chip>
                <v-chip
                    class="ml-2"
                    color="primary"
                    text-color="white"
                    v-show="role && role.host_s"
                    >
                    セミナー開催
                </v-chip>
                <v-chip
                    class="ml-2"
                    color="primary"
                    text-color="white"
                    v-show="role && role.attend_g"
                    >
                    グルコン参加
                </v-chip>
                <v-chip
                    class="ml-2"
                    color="primary"
                    text-color="white"
                    v-show="role && role.host_g"
                    >
                    グルコン開催
                </v-chip>
                <v-chip
                    class="ml-2"
                    color="primary"
                    text-color="white"
                    v-show="role && role.admin"
                    >
                    管理者
                </v-chip>
            </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <!-- <v-tabs v-model="tab">
            <v-tab :key="actionLog">活動記録</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item
                :key="actionLog"
            >
                <v-card flat>
                    <template>
                    <ChartLayout
                        :navItem='"host"'
                        :event_type='"S"'></ChartLayout>
                    </template>
                </v-card>
            </v-tab-item>
        </v-tabs-items> -->
    </v-container>
</template>

<script>
    import { mapGetters } from "vuex";
    // import ChartLayout from './ChartLayout.vue'
    
    export default {
        computed: {
            ...mapGetters(["userName", "photoURL", 'chatwork_id', 'uid', 'role', 'login_user'])
        },
        // components: {
        //     ChartLayout,
        // },
        mounted(){
            this.targetId = this.uid;

        },
        data() {
            return {
                tab: null,
                targetId : null,
            };
        },
        methods:{

        }
    };
</script>
